<section id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2> {{lang?.appointment_data_processor}} </h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{lang?.privacy}}
            </a>
          </li>
          <li>{{ lang?.appointment_data_processor }}</li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body deadline-name">
              <div role="tabpanel">

                <div class="row p-10">

                  <div class="col-sm-2">
                    <div class="social-icons">

                      <a class="plus-add toottip" (click)="addEditTreatmentRegister('Add')"
                        [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                        <i class="fa fa-plus"></i>
                      </a>

                      <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                        data-options="splash-2 splash-ef-4" title="Export">
                        <span class="glyphicon glyphicon-export"></span>
                      </a>

                      <a class="plus-import" data-toggle="modal" data-target="#datatableExport2" data-action="show"
                        data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Import">
                        <span class="glyphicon glyphicon-import"></span>
                      </a>

                      <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id=""
                        [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                        <span class="glyphicon glyphicon-file"></span>
                      </a>


                      <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()"
                        [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                        <span class="glyphicon glyphicon-trash"></span>
                      </a>

                    </div>
                  </div>

                  <div class="col-sm-2">
                    <select class="form-control" (change)="datatableFilterAction()" [(ngModel)]="filter1">
                      <option value>{{ lang?.select_type }}</option>
                      <option value="{{ lang?.quality }}">{{ lang?.quality }}</option>
                      <option value="{{ lang?.safety }}">{{ lang?.safety }}</option>
                      <option value="{{ lang?.environment }}">{{ lang?.environment }}</option>
                      <option value="{{ lang?.administration }}">{{ lang?.administration }}</option>
                      <option value="{{ lang?.various }}">{{ lang?.various }}</option>
                    </select>
                  </div>

                  <div class="col-sm-2">
                    <select class="form-control" (change)="datatableFilterAction()" [(ngModel)]="filter2"
                      name="status_change" data-column="17">
                      <option value>{{ lang?.selectStatus }}</option>
                      <option value="1">{{ lang?.all }}</option>
                      <option value="2">{{ lang?.expired }}</option>
                      <option value="3">{{ lang?.notExpired }}</option>
                    </select>
                  </div>

                  <!-- <div class="col-sm-1">
                    <div class="social-icons">

                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>

                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>

                    </div>
                  </div> -->

                  <div  class="col-sm-2">
                    <input
                    #treatmentSearch
                    id="treatmentSearch"
                    type="text"
                    class="form-control"
                    [placeholder]="lang?.search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                  />                        
                  </div>                      

                </div>

                <div class="table-responsive" style="overflow: auto;">

                  <table datatable [dtOptions]="datatableOptions" class="table-striped table-sm row-border hover" id="table1">
                    <thead>
                      <tr>
                        <th>Hidden.No</th>
                        <th>
                          <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                            <input type="checkbox"><i></i>
                          </label>
                        </th>
                        <th>{{ lang.no }}</th>
                        <th>{{ lang?.name }}</th>
                        <th>{{ lang?.function }}</th>
                        <th>{{ lang?.type_of_function }}</th>
                        <th>{{ lang?.treatment_carried_out }}</th>
                        <th>{{ lang?.desc_of_assigned_tasks }}</th>
                        <th>{{ lang?.desc_of_responsiblties }}</th>
                        <th>{{ lang?.appointment_data_processor }}</th>
                        <th>{{ lang?.action }}</th>
                      </tr>
                    </thead>

                    <tbody dragula="records" [(dragulaModel)]="records">
                      <tr *ngFor="let record of records let i = index" id="{{record.timetabelId}}">
                        <td>{{i+1}}</td>
                        <td></td>
                        <td>{{i+1}}</td>
                        <td>{{record.code}}</td>
                        <td>{{ record?.description_treatment }} </td>
                        <td>-</td>
                        <td>{{record?.type}}</td>
                        <td>{{record?.tools_data_processing}}</td>
                        <td>{{record?.physical_location_data_storage}}</td>
                        <td>{{record?.type_access_to_computer_data}}</td>
                        <td>
                          <div class="btn-group dropup">

                            <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
                              aria-expanded="false"><i class="fa fa-tasks"></i></button>

                            <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                              <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                  class="delete_action" (click)="delete(record.treatment_creation_id)"><i class="fa fa-trash"></i>
                                  {{lang?.erase}}</a></li>

                              <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                (click)="addEditTreatmentRegister('Edit', record?.treatment_creation_id)" class="edit_action"><i class="fa fa-edit"></i> {{lang?.modify}}</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

